import create from 'zustand';

import { type Locale } from './types';

const STORAGE_KEY = 'tracking_locale';

const getInitialLocale = (): Locale => {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'en' || stored === 'da') {
    return stored;
  }

  return navigator.language.toLowerCase().startsWith('da') ? 'da' : 'en';
};

type LocaleState = {
  locale: Locale;
  setLocale: (locale: Locale) => void;
};

const useLocaleStore = create<LocaleState>((set) => ({
  locale: getInitialLocale(),
  setLocale: (locale) => {
    localStorage.setItem(STORAGE_KEY, locale);
    set({ locale });
  },
}));

export { useLocaleStore, STORAGE_KEY };
